module.exports = __webpack_public_path__ + "img/dev_win.5fd30f86.png";